'use client';

import { AnimatePresence } from 'framer-motion';
import { Toast } from './toast';
import type { Toast as ToastType } from '@/types/ui.types';

interface ToastContainerProps {
  toasts: ToastType[];
  onRemove: (id: string) => void;
}

/**
 * Toast 알림들을 담는 컨테이너
 */
export function ToastContainer({ toasts, onRemove }: ToastContainerProps) {
  return (
    <div className="fixed top-4 right-4 z-[9999] space-y-2">
      <AnimatePresence>
        {toasts.map(toast => (
          <Toast key={toast.id} toast={toast} onClose={onRemove} />
        ))}
      </AnimatePresence>
    </div>
  );
}
